import { AddSmall, DismissSmall } from '@wix/wix-ui-icons-common';
import classNames from 'classnames';
import React, { useContext } from 'react';

import { RicosContext } from './../../../ricos-context';

import { ADD_PLUGIN_FLOATING_TOOLBAR } from './data-hooks';
import styles from './styles/floating-add-plugin-menu.rtlignore-scss';

type PlusButtonProps = {
  onClick: () => void;
  position?: { top: string };
  rotate?: boolean;
  direction: string;
};

const PlusButton = React.forwardRef<HTMLButtonElement, PlusButtonProps>(
  ({ position, onClick, rotate, direction }, ref) => {
    const { tabIndex } = useContext(RicosContext);

    return (
      <button
        type="button"
        data-hook={ADD_PLUGIN_FLOATING_TOOLBAR}
        ref={ref}
        onClick={onClick}
        className={classNames(
          styles.floatingAddPluginMenu_plus_button_position,
          styles.floatingAddPluginMenu_plus_button,
          styles[direction]
        )}
        style={position}
        tabIndex={tabIndex}
      >
        {rotate ? <DismissSmall fill="currentColor" /> : <AddSmall fill="currentColor" />}
      </button>
    );
  }
);

export default PlusButton;
